/** One shared AudioContext, created on the first user gesture (browsers block audio before that). */
let context: AudioContext | null = null;
let muted = false;

export function audioContext(): AudioContext | null {
  if (muted) return null;
  if (!context) {
    try {
      context = new AudioContext();
    } catch {
      return null;
    }
  }
  if (context.state === 'suspended') void context.resume();
  return context;
}

export function setMuted(value: boolean): void {
  muted = value;
  if (muted) void context?.suspend();
  else void context?.resume();
}

export function isMuted(): boolean {
  return muted;
}

/** Resume audio on the first tap/click/key, as browsers require. */
export function unlockAudioOnGesture(onUnlock?: () => void): void {
  const unlock = (): void => {
    audioContext();
    onUnlock?.();
    window.removeEventListener('pointerdown', unlock);
    window.removeEventListener('keydown', unlock);
  };
  window.addEventListener('pointerdown', unlock);
  window.addEventListener('keydown', unlock);
}
